export default {
  documentType: '',
  documentFront: '',
  documentBack: '',
  facematchStatus: '',
};
